import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";

interface PageHeaderProps {
  breadcrumbs: { label: string; href?: string }[];
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function PageHeader({
  breadcrumbs,
  title,
  subtitle,
  actions,
}: PageHeaderProps) {
  return (
    <div className="mb-6">
      {breadcrumbs.length > 1 && (
        <Breadcrumb className="mb-2 typo-body">
          <BreadcrumbList>
            {breadcrumbs.map((crumb, i) => {
              const isLast = i === breadcrumbs.length - 1;
              return (
                <BreadcrumbItem key={crumb.label}>
                  {!isLast && crumb.href ? (
                    <BreadcrumbLink
                      href={crumb.href}
                      className="text-[color:var(--color-text-lo)]"
                    >
                      {crumb.label}
                    </BreadcrumbLink>
                  ) : (
                    <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                  )}
                  {!isLast && (
                    <BreadcrumbSeparator className="text-[color:var(--color-text-lo)]">
                      /
                    </BreadcrumbSeparator>
                  )}
                </BreadcrumbItem>
              );
            })}
          </BreadcrumbList>
        </Breadcrumb>
      )}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="typo-heading text-[color:var(--color-text-hi)]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 typo-body text-[color:var(--color-text-md)]">
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
